module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/83f622175588a5129513907505a95062.png";